import { graphql } from "gql.tada";

// All page archetypes have slug, title, navigation fields directly.
// We spread on each archetype since they're in the NavigationItemItemsItem union.
export const GetRootNavigationItem = graphql(
  `
    query GetRootNavigationItem(
      $locale: String
      $preview: Boolean
      $allowedChildren: Int = 10
    ) {
      navigationItemCollection(
        preview: $preview
        where: { title: "Root Navigation" }
        limit: 1
      ) {
        items {
          __typename
          title(locale: $locale)
          itemsCollection(limit: $allowedChildren, locale: $locale) {
            items {
              __typename
              ...PageArchetypeNavFields
              ... on NavigationItem {
                title(locale: $locale)
                itemsCollection(limit: $allowedChildren, locale: $locale) {
                  items {
                    __typename
                    ...PageArchetypeNavFields
                    ... on NavigationItem {
                      title(locale: $locale)
                    }
                  }
                }
              }
            }
          }
          menuAccessibilityLabel(locale: $locale)
        }
      }
    }

    fragment NavPageFields on NavigationItemItemsItem {
      ... on ContentHubPage {
        slug(locale: $locale)
        title(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
      ... on ConversionPage {
        slug(locale: $locale)
        title(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
      ... on EditorialPage {
        slug(locale: $locale)
        title(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
      ... on FaqPage {
        slug(locale: $locale)
        internalName(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
      ... on Homepage {
        slug(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
      ... on ProductPage {
        slug(locale: $locale)
        title(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
... on TermsPage {
        slug(locale: $locale)
        title(locale: $locale)
        navigationImage(locale: $locale) { url title }
        navigationAlternateLabel(locale: $locale)
        navigationAccessibilityLabel(locale: $locale)
      }
    }

    fragment PageArchetypeNavFields on NavigationItemItemsItem {
      ...NavPageFields
    }
  `
);
